import { Breadcrumbs } from "@/shared/components/layout/Breadcrumbs";
import { PageHeader } from "@/shared/components/layout/PageHeader";
import { Card } from "@/shared/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/shared/components/ui/table";
import { InfoCountCard } from "../components/InfoCountCard";
import { useMediaApiVersion } from "../hooks/useMediaApiVersion";

export function InfoMediaApiVersionPage() {
  const vm = useMediaApiVersion();

  return (
    <div className="space-y-6">
      <Breadcrumbs />
      <PageHeader
        title="미디어 API 버전"
        description="프리즘 media-api 서비스에서 지원되는 각 매체의 API 버전을 조회합니다."
      />

      <div className="w-full flex justify-center gap-9">
        <InfoCountCard label="전체 개수" value={vm.summary.itemsLength} valueClassName="text-teal-600" />
        <InfoCountCard label="채널 개수" value={vm.summary.channelCount} valueClassName="text-emerald-700" />
      </div>

      <div className="flex justify-center">
        <Card className="w-full max-w-[1200px] p-0 overflow-hidden">
          {vm.isLoading ? (
            <div className="p-6 text-muted-foreground">로딩 중...</div>
          ) : vm.isError ? (
            <div className="p-6 text-muted-foreground">
              서비스가 일시적으로 이용 불가능합니다. 잠시 후 다시 시도해 주세요.
            </div>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead className="text-center w-[220px]">채널</TableHead>
                  <TableHead className="text-center w-[260px]">서브 채널</TableHead>
                  <TableHead className="text-center">버전</TableHead>
                </TableRow>
              </TableHeader>

              <TableBody>
                {vm.rows.map((r, idx) => (
                  <TableRow key={`${idx}-${r.channel}-${r.subChannel}`}>
                    {r.channel !== "" && (
                      <TableCell className="text-center font-bold align-middle" rowSpan={r.rowSpan}>
                        {r.channel}
                      </TableCell>
                    )}
                    <TableCell className="text-center">{r.subChannel}</TableCell>
                    <TableCell className="text-center">{r.versions}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </Card>
      </div>
    </div>
  );
}